module.exports = __webpack_public_path__ + "img/icon45.acbc3cb3.png";